<pf-content>
    @if (printViewOptions(); as printViewOptions) {
        <div id="print-labels-container">
            <article pfArticle pfTitle="Print Settings" id="print-settings">
                <platform-print-label-settings
                    #printSettings
                    [labelCount]="selectedLabels().length"
                    (settingsChanged)="
                        onSettingsChanged($event)
                    "></platform-print-label-settings>
                <platform-auto-print-countdown
                    #autoCountdown
                    (completed)="
                        printSelectedLabels()
                    "></platform-auto-print-countdown>
                @if (autoCountdown.countdown() === null) {
                    <div id="print-action-buttons">
                        <pf-button
                            buttonType="download"
                            [disabled]="selectedLabels().length === 0"
                            [loading]="downloading()"
                            (click)="downloadSelectedLabels()">
                            Download selected
                        </pf-button>
                        <pf-button
                            buttonType="print"
                            [disabled]="
                                selectedLabels().length === 0 ||
                                !printSettings.valid
                            "
                            [loading]="printing()"
                            (click)="printSelectedLabels()">
                            Print selected
                        </pf-button>
                    </div>
                }
            </article>
            <article
                pfArticle
                [pfTitle]="printViewOptions.labelsTitle"
                id="labels">
                @if (data.parentLabel) {
                    <pf-checkbox
                        label="Print parent label"
                        pfStyle="compact"
                        [control]="printParentControl"
                        (change)="onPrintParentChange()"></pf-checkbox>
                }
                <nz-table
                    #labelsTable
                    nzSize="small"
                    [nzBordered]="true"
                    [nzOuterBordered]="true"
                    [nzShowPagination]="false"
                    [nzFrontPagination]="false"
                    [nzData]="data.labels">
                    <thead>
                        <tr>
                            <th
                                [nzChecked]="checked"
                                [nzIndeterminate]="indeterminate"
                                nzLabel="Select all"
                                nzWidth="60px"
                                (nzCheckedChange)="onAllChecked($event)"></th>
                            <th>
                                Select all ({{ data.labels.length }}
                                {{ printViewOptions.labelTypeText }})
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (
                            labelOptions of labelsTable.data;
                            track labelOptions.barcode
                        ) {
                            <tr>
                                <td
                                    [nzChecked]="
                                        setOfCheckedId().has(
                                            labelOptions.barcode
                                        )
                                    "
                                    [nzLabel]="labelOptions.barcode"
                                    (nzCheckedChange)="
                                        onItemChecked(
                                            labelOptions.barcode,
                                            $event
                                        )
                                    "></td>
                                <td class="label-barcode-cell">
                                    <div class="label-info">
                                        <span>{{ labelOptions.barcode }}</span>
                                        @for (
                                            tag of labelOptions.tags;
                                            track tag
                                        ) {
                                            <pf-chip>{{ tag }}</pf-chip>
                                        }
                                    </div>
                                    <pf-button
                                        buttonType="view"
                                        (click)="viewLabel(labelOptions)">
                                        Preview
                                    </pf-button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </nz-table>
            </article>
        </div>
    }
</pf-content>
<nz-modal
    [nzVisible]="!!previewLabel()"
    nzTitle="Label Preview"
    (nzOnCancel)="closePreview()"
    [nzFooter]="null"
    [nzWidth]="'90vw'"
    [nzCentered]="true">
    <ng-container *nzModalContent>
        @if (previewLabel(); as label) {
            <platform-zpl-preview
                [zpl]="label.zpl"
                [fileName]="label.barcode"
                [widthInches]="data.widthInches"
                [heightInches]="data.heightInches"></platform-zpl-preview>
        }
    </ng-container>
</nz-modal>
